import { css } from "@emotion/css";
import PreviewIcon from "@mui/icons-material/Preview";
import util from "digimaker-ui/util";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { imagePath } from "shared/src/widgets/util";

export const ImagePreview = (props: { content }) => {
  const { content } = props;

  const [shown, setShown] = useState(false);
  const handle = (e) => {
    setShown(true);
  };

  const thumbnailUrl = imagePath(content.image, true);
  const imageUrl = imagePath(content.image);

  return (
    <div>
      <div
        className={css`
          cursor: pointer;
          margin-top: 5px;

          :hover {
            opacity: 0.8;
          }

          img {
            height: 80px;
            object-fit: contain;
          }
        `}
        onClick={handle}
      >
        <img src={thumbnailUrl} />
      </div>
      <Modal
        size="lg"
        show={shown}
        onHide={() => {
          setShown(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{content.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <img src={imageUrl} />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
